<div class="page-body">
  <!--profile cover start-->
  <div class="row">
    <!-- Right column start -->
    <div class="col-xl-3 col-lg-12">
      <!-- profile start -->
      <profile-card
        [profile]="profile"
        (onToggleFollowing)="onToggleFollowing($event)"
      ></profile-card>
    </div>
    <!-- Right column end -->

    <!-- Left column start -->
    <div class="col-xl-9 col-lg-12">
      <profile-nav-tabs [profile]="profile" [ownsProfile]="ownsProfile">
      </profile-nav-tabs>
      <router-outlet></router-outlet>
    </div>
    <!-- Left column end -->
  </div>
</div>
